import { render, staticRenderFns } from "./NutritionalValue.vue?vue&type=template&id=5ae3378c&scoped=true&"
import script from "./NutritionalValue.vue?vue&type=script&lang=js&"
export * from "./NutritionalValue.vue?vue&type=script&lang=js&"
import style0 from "./NutritionalValue.vue?vue&type=style&index=0&id=5ae3378c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae3378c",
  null
  
)

export default component.exports